// eslint-disable-next-line import/no-extraneous-dependencies
import { configureStore } from '@reduxjs/toolkit';
import initialDataReducer from './reducers/initialdata-reducer';
import accountReducer from './reducers/account-reducer';
import peopleReducer from './reducers/people-reducer';
import planReducer from './reducers/plan-reducer';

export default configureStore({
  reducer: {
    people: peopleReducer,
    account: accountReducer,
    initialData: initialDataReducer,
    plan: planReducer
  }
});
